import { ReportSdk } from 'lib-klab-sdks';
import { WebActivityReportItem, WebActivityReportMetadata, WebActivityReportPage, WebActivityReportResponse } from '../../../domain/models/reports/web-activity-report.model';
import { DateRange } from '../../../domain/models/reports/request/web-activity-report.request';
import { WebClassification, WebsTopWithPercentageMetadata, WebsTopWithPercentageResponse, WebTopItemWithPercentage } from '../../../domain/models/reports/webs-top-percentage.model';


export function mapSdkDateRangeToDomain(dr?: ReportSdk.DateRange): DateRange | undefined {
    if (!dr) return undefined;
    return {
        startDate: dr.startDate,
        endDate: dr.endDate,
    };
}

export function mapSdkWebActivityMetadataToDomain(
    metadata?: ReportSdk.WebActivityListResponseMetadata,
): WebActivityReportMetadata {
    return {
        employeeId: metadata?.employeeId,
        dateRange: mapSdkDateRangeToDomain(metadata?.dateRange),
    };
}

export function mapSdkPaginationToDomain(page?: ReportSdk.PaginationResponse): WebActivityReportPage {
    return {
        page: page?.page ?? 0,
        size: page?.size ?? 0,
        totalElements: page?.totalElements ?? 0,
        totalPages: page?.totalPages ?? 0,
    };
}

export function mapSdkWebActivityItemToDomain(item: ReportSdk.WebActivityItem): WebActivityReportItem {
    return {
        browser: item.browser,
        title: item.title,
        domain: item.domain,
        url: item.url,
        startAt: item.startAt,
        endedAt: item.endedAt,
        activeSeconds: item.activeSeconds,
        idleSeconds: item.idleSeconds,
        totalSeconds: item.totalSeconds,
    };
}

export function mapSdkWebActivityListResponseToDomain(
    resp: ReportSdk.WebActivityListResponse,
): WebActivityReportResponse {
    return {
        metadata: mapSdkWebActivityMetadataToDomain(resp?.metadata),
        content: (resp?.content ?? []).map(mapSdkWebActivityItemToDomain),
        page: mapSdkPaginationToDomain(resp?.page),
    };
}

export function mapSdkWebsTopMetadataToDomain(
    metadata?: ReportSdk.GroupedWebsResponseMetadata,
): WebsTopWithPercentageMetadata {
    return {
        employeeId: metadata?.employeeId,
        dateRange: mapSdkDateRangeToDomain(metadata?.dateRange),
        totalSeconds: metadata?.totalSeconds,
    };
}

export function mapSdkWebTopItemToDomain(item: ReportSdk.GroupedWebItem): WebTopItemWithPercentage {
    return {
        domain: item.domain,
        totalSeconds: item.totalSeconds,
        classification: (item.classification as WebClassification) || undefined,
    };
}

export function mapSdkWebsTopWithPercentageResponseToDomain(
    resp: ReportSdk.GroupedWebsResponse,
): WebsTopWithPercentageResponse {
    return {
        metadata: mapSdkWebsTopMetadataToDomain(resp?.metadata),
        content: (resp?.content ?? []).map(mapSdkWebTopItemToDomain),
    };
}